export default "__VITE_ASSET__$S8v0J27__"